import React from "react";
import { Col, FormGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import { defineMessages, FormattedMessage } from "react-intl";

const messages = defineMessages({
  editNotAllowed: {
    id: "extras.form.editNotAllowed",
    defaultMessage: "This extra can’t be modified from this property. To edit ",
  },
  editClickHere: {
    id: "extras.form.editClickHere",
    defaultMessage: "click here",
  },
});

type EditNotAllowedFormLabelProps = {
  linkTo: string;
};

export function EditNotAllowedFormLabel({ linkTo }: EditNotAllowedFormLabelProps) {
  return (
    <FormGroup as={Col} className="witadmin-bs3">
      <div className="bg-danger-light rounded-sm p-2">
        <span className="text-danger-light font-weight-normal">
          <FormattedMessage {...messages.editNotAllowed} />
          <Link to={linkTo}>
            <FormattedMessage {...messages.editClickHere} />
          </Link>
        </span>
      </div>
    </FormGroup>
  );
}
